/* global d365mktforms */
/**
 * ROC van Twente
 *
 * @author Robuust
 * @author Gijs Stegehuis <gijs@robuust.digital>
 *
 * see: https://learn.microsoft.com/en-us/dynamics365/customer-insights/journeys/developer/realtime-marketing-form-client-side-extensibility
 * see: https://learn.microsoft.com/en-us/dynamics365/customer-insights/journeys/developer/marketing-form-client-side-extensibility#form-events
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    formId: String,
    endpoint: String,
    cachedFormUrl: String,
    readableEventId: String,
  };

  static classes = ['loading'];

  /**
   * Connects the controller.
   */
  connect() {
    this.element.classList.add(this.loadingClass);
    const form = d365mktforms.createForm(
      this.formIdValue,
      this.endpointValue,
      this.cachedFormUrlValue,
      {
        'data-readable-event-id': this.readableEventIdValue,
      },
    );
    form.addEventListener('d365mkt-afterformload', () => {
      this.element.classList.remove(this.loadingClass);
    });

    this.element.appendChild(form);
  }

  /**
   * Destroys the form when the controller is disconnected.
   */
  disconnect() {
    this.element.lastChild.remove();
  }
}
